import React from 'react';
import { motion } from 'framer-motion';
import { Facebook, Instagram, Twitter } from 'lucide-react';
export function HeroSection() {
  return <section id="home" className="relative min-h-screen flex items-center pt-20 bg-primary overflow-hidden" data-id="element-94">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-95">
        <div className="absolute inset-0 bg-primary/40 z-10" data-id="element-96"></div>
        <img src="https://cdn.magicpatterns.com/uploads/23RgAriFeiSrJUnCtub4jC/minimalist-black-interior-with-black-sofa.jpg" alt="Dark minimalist interior with pendant lights" className="w-full h-full object-cover" data-id="element-97" />
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-20 pt-20" data-id="element-98">
        <div className="max-w-4xl" data-id="element-99">
          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-white text-5xl md:text-7xl lg:text-8xl font-heading font-bold uppercase leading-[0.9] tracking-tight" data-id="element-100">
            We Shine, <br data-id="element-101" />
            When You{' '}
            <span className="font-script text-white lowercase tracking-normal text-6xl md:text-8xl lg:text-9xl ml-2 font-normal" data-id="element-102">
              Shine!
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="text-white/80 mt-8 text-lg md:text-xl max-w-md font-light leading-relaxed" data-id="element-103">
            No residential, commercial
            <br data-id="element-104" />
            nor spring/deep clean
            <br data-id="element-105" />
            is too big or too small.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="mt-12 flex items-center gap-6" data-id="element-106">
            <a href="#" className="hover:opacity-80 transition-opacity" data-id="element-107">
              <img src="https://cdn.magicpatterns.com/uploads/e3r1rj47crZgXHRpz1A67c/sj-website-cta-book-online.svg" alt="Book Online" className="h-11 md:h-12" data-id="element-108" />
            </a>

            <div className="flex items-center gap-4 ml-auto md:ml-0" data-id="element-109">
              <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-white/10 transition-colors" data-id="element-110">
                <Facebook size={18} data-id="element-111" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-white/10 transition-colors" data-id="element-112">
                <Instagram size={18} data-id="element-113" />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}